
import { Link } from 'react-router-dom';

interface LinkItem {
  title: string;
  path: string;
  icon: string;
}

interface InternalLinksProps {
  title: string;
  links: LinkItem[];
  variant?: 'grid' | 'list';
}

export default function InternalLinks({ title, links = [], variant = 'grid' }: InternalLinksProps) {
  // Eğer links boş ise bileşeni render etme
  if (!links || links.length === 0) {
    return null;
  }

  return (
    <section className="py-12 bg-dark-900/50 rounded-2xl">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center">
          {title}
        </h2>
        
        <div className={variant === 'grid' 
          ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          : "space-y-4"
        }>
          {links.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className="group bg-dark-800/50 hover:bg-dark-800 border border-dark-700 hover:border-primary-500/50 rounded-xl p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-primary-500/10"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 rounded-lg group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className={`${link.icon} text-2xl text-primary-400`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-white group-hover:text-primary-400 transition-colors duration-300 mb-2">
                    {link.title}
                  </h3>
                  <div className="flex items-center text-primary-400 text-sm font-medium">
                    <span>Detaylı Bilgi</span>
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
